import { render } from "./ReportPage.vue?vue&type=template&id=e571e866"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"
script.render = render

export default script